// Calls notifyFunc on msgs.  If msgs is an array, then notifyFunc is called on each member of the array.
export const notify = (msgs, notifyFunc) => {
  if (!msgs) return;

  if (Array.isArray(msgs)) {
    msgs.map(m => {
      notifyFunc(m);
    });
  } else {
    notifyFunc(msgs);
  }
};